// import env from "../env/env.prod";
import fire from '../config/fire';
export function isLoggedIn()  {
  let  user = fire.auth().currentUser;
  if (user) {
    return 1;
  }
  return 0;
}
